import { render, staticRenderFns } from "./BoostingPage.vue?vue&type=template&id=0865a3c7&scoped=true&"
import script from "./BoostingPage.vue?vue&type=script&lang=js&"
export * from "./BoostingPage.vue?vue&type=script&lang=js&"
import style0 from "./BoostingPage.vue?vue&type=style&index=0&id=0865a3c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0865a3c7",
  null
  
)

export default component.exports